import {FlatButton} from 'material-ui';
import {graphql, compose} from 'react-apollo';
import React, {Component} from 'react';

import {ArtCollectionQuery, ArtCollectionQueryConfig} from '../qql-shared/queries';
import {HeadlineH1, HeadlineH2} from '../components/text/Headlines';
import ActionButtonRow from '../components/ActionButtonRow';
import ArtCollectionEdit from '../components/ArtCollectionEdit';
import ErrorMessage from '../components/ErrorMessage';
import SuccessMessage from '../components/SuccessMessage';
import Dialog from 'material-ui/Dialog';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {Trans, withNamespaces} from 'react-i18next';

export const Report = styled.div`
  display: flex;
  flex-wrap: wrap;
  > * {
    flex: 50%;
  }
`;

class ArtCollections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      messages: [],
      publishConfirmationDialogConfig: null,
    };
  }
  componentWillReceiveProps(newProps) {}

  _goBackToList = () => this.props.history.goBack();

  _renderButtons = () => {
    const {t} = this.props;
    return (
      <ActionButtonRow>
        <FlatButton onClick={this._goBackToList} label={t('collections.back')} />
      </ActionButtonRow>
    );
  };

  setNotifications = (messages, errors, t) => {
    this.setState({messages, errors});
  };

  _renderCollections = (collections) => {
    if (collections && collections.length > 0) {
      return (
        <div>
          {collections.map(({_id, name, owner}) => (
            <div key={_id}>
              <Link to={`/art-collections/${owner._id}`}>
                <b>{name}</b> ({owner.name})
              </Link>
            </div>
          ))}
        </div>
      );
    } else {
      const {t} = this.props;
      return <b>{t('collections.noVisibleCollections')}</b>;
    }
  };

  _getName = () => (this.props.data.user && this.props.data.user.name) || '';

  _renderReport = () => {
    const {user = {}} = this.props.data;
    const {t} = this.props;
    let name = this._getName();
    return (
      <Report>
        <HeadlineH2>{t('collections.visibleApp')}</HeadlineH2>
        <HeadlineH2>{t('collections.visiblePotentially')}</HeadlineH2>
        <Trans i18nKey='collections.description'>
          <p>
            Diese Sammlungen sieht <b>{{name}}</b> in der App.
          </p>
          <p>
            Diese Sammlungen wären für <b>{{name}}</b> in der App sichtbar wenn alle Änderungen veröffentlicht werden.
            <br />
            Für eine genaue Kontrolle vor der Veröffentlichung sieht ein Mitarbeiter auch unveröffentlichte Änderungen
            in der App.
          </p>
          <div>{this._renderCollections(user.publishedAllowedArtCollections)}</div>
          <div>{this._renderCollections(user.unpublishedAllowedArtCollections)}</div>
        </Trans>
      </Report>
    );
  };

  _renderOwnedArtCollections = () => {
    const {
      data: {allClients, user},
    } = this.props;
    if (!user) return null;
    const ownedArtCollections = user.unpublishedOwnedArtCollections;
    return (
      <div>
        {ownedArtCollections &&
          ownedArtCollections.length > 0 &&
          ownedArtCollections.map((artCollection, idx) => (
            <ArtCollectionEdit
              key={artCollection._id}
              artCollection={artCollection}
              allClients={allClients}
              setNotifications={this.setNotifications}
              setPublishConfirmDialog={this.setPublishConfirmDialog}
              startPolling={this.props.data.startPolling}
              stopPolling={this.props.data.stopPolling}
            />
          ))}
        <ArtCollectionEdit
          artCollection={{owner: {_id: this.props.match.params.userId}}}
          allClients={allClients}
          addNew={true}
          setNotifications={this.setNotifications}
          setPublishConfirmDialog={this.setPublishConfirmDialog}
        />
      </div>
    );
  };

  setPublishConfirmDialog = (config) => {
    console.log(config);
    this.setState({publishConfirmationDialogConfig: config});
  };

  _renderPublishConfirmationDialog = () => {
    const {publishConfirmationDialogConfig: config} = this.state;
    const {onConfirm, artCollection, viewer, text} = config || {};
    const {t} = this.props;
    console.log('text', text);
    return (
      <Dialog
        title={t('collections.publisheChange')}
        open={!!config}
        modal
        actions={[
          <FlatButton label={t('collections.cancel')} onClick={() => this.setPublishConfirmDialog(null)} />,
          <FlatButton
            label={t('collections.yes')}
            primary
            onClick={() => {
              this.setPublishConfirmDialog(null);
              onConfirm();
            }}
          />,
        ]}>
        {text}
        {!text && (
          <Trans i18nKey='collections.text'>
            {{artCollection}} {{viewer}} .
          </Trans>
        )}
        <br />
        <br />
        {t('collections.confirmText')}
      </Dialog>
    );
  };

  render() {
    const {t} = this.props;
    return (
      <div>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        <SuccessMessage messages={this.state.messages} clearMessages={() => this.setState({messages: []})} />
        <HeadlineH1>
          {t('collections.header')} - {this._getName()}
        </HeadlineH1>
        {this._renderReport()}
        <HeadlineH2>{t('collections.ownCollection')}</HeadlineH2>
        {this._renderOwnedArtCollections()}
        {this._renderButtons()}
        {this._renderPublishConfirmationDialog()}
      </div>
    );
  }
}

export default withNamespaces()(compose(graphql(ArtCollectionQuery, ArtCollectionQueryConfig))(ArtCollections));



// WEBPACK FOOTER //
// ./src/containers/ArtCollections.js